import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import authActions from "../Auth/actions";
import actions from "./actions";
import {
  CHANGE_PASSWORD,
  DELETE_USER,
  LOAD_USERS,
  UPDATE_USER_PROFILE,
  USERS_EDIT_MODAL_OPEN_AND_FETCH,
  USERS_VIEW_MODAL_OPEN_AND_FETCH,
  USER_EDIT,
  USER_SAVE,
} from "./constants";

const {
  usersModalSetUser,
  loadUsers: loadUsersAction,
  loadUsersPending,
  loadUsersSuceess,
  loadUsersFailure,
  saveUserPending,
  saveUserSuccess,
  saveUserFailure,
  deleteUserPending,
  deleteUserSuccess,
  deleteUserFailure,
  editUserPending,
  editUserSuccess,
  editUserFailure,
  updateUserProfilePending,
  updateUserProfileSuccess,
  updateUserProfileFailure,
  chagePasswordSuccess,
  chagePasswordFailure,
} = actions;
const { loginSuccess } = authActions;
// Individual exports for testing
export function* openUsersViewModal({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const userResponse = yield call(api(token).get, `/api/users/${payload}`);
    if (userResponse.data && userResponse.data.id) {
      yield put(usersModalSetUser(userResponse.data));
    }
  } catch (e) {
    yield put(errorAlert("Error while retrieving user!"));
  }
}
// using a single action to set user for view and edit
export function* openUsersEditModal({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const isViewModalOpen = yield select(
    (state) => state?.UserReducer?.isViewModalOpen
  );
  const currentUser = yield select((state) => state?.UserReducer?.currentUser);
  try {
    if (isViewModalOpen && currentUser?.id === payload) {
      yield put(usersModalSetUser(currentUser));
    } else {
      const { data } = yield call(api(token).get, `/api/users/${payload}`);
      if (data && data.id) {
        yield put(usersModalSetUser(data));
      }
    }
  } catch (e) {
    yield put(errorAlert("Error while retrieving user!"));
  }
}
export function* openUsersViewModalFlow() {
  yield takeEvery(USERS_VIEW_MODAL_OPEN_AND_FETCH, openUsersViewModal);
}
export function* openUsersEditModalFlow() {
  yield takeEvery(USERS_EDIT_MODAL_OPEN_AND_FETCH, openUsersEditModal);
}

export function* loadUsers({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(loadUsersPending({ isLoadingUsers: true }));
  try {
    const { cancelToken, page } = payload;
    const { data } = yield call(
      api(token, cancelToken).get,
      `/api/users?${page ? QueryString.stringify({ page }) : ""}`
    );

    yield put(loadUsersSuceess(data));
  } catch (e) {
    yield put(errorAlert("Error while retrieving users!"));
    yield put(loadUsersFailure({ error: e }));
  }
}

export function* saveUser({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(saveUserPending({ isUserSaving: true }));
  try {
    const saveResponse = yield call(
      api(token).post,
      `/api/users/add`,
      payload.formdata
    );
    yield put(successAlert("User created successfully!"));
    yield put(saveUserSuccess({ users: saveResponse.data }));
    yield put(loadUsersAction());
  } catch (error) {
    yield put(
      errorAlert(typeof error === "string" ? error : "Error while saving user!")
    );
    yield put(saveUserFailure({ error: error }));
  }
}

export function* deleteUser({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(deleteUserPending({ isUserDeleting: true }));
  try {
    const deleteResponse = yield call(
      api(token).delete,
      `api/users/${payload}`
    );
    yield put(deleteUserSuccess({ message: deleteResponse.message }));
    yield put(successAlert("User deleted successfully!"));
    yield put(loadUsersAction());
  } catch (error) {
    yield put(
      errorAlert(
        typeof error === "string" ? error : error.response.data.message
      )
    );
    yield put(deleteUserFailure({ error: error }));
  }
}

// Edit user
export function* editUser({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const currentUser = yield select((state) => state?.UserReducer?.currentUser);
  yield put(editUserPending({ isUserSaving: true }));
  try {
    const editResponse = yield call(
      api(token).post,
      `/api/users/edit/${currentUser.id}`,
      payload.formdata
    );
    yield put(editUserSuccess({ message: editResponse.data }));
    yield put(loadUsersAction());
    yield put(successAlert("User edited successfully!"));
  } catch (error) {
    yield put(
      errorAlert(typeof error === "string" ? error : "Error while saving user!")
    );
    yield put(editUserFailure({ error: error }));
  }
}

// Update user profile
export function* updateUserProfile({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(updateUserProfilePending({ isUserSaving: true }));
  try {
    const profileResponse = yield call(
      api(token).post,
      `api/users/self/edit`,
      payload
    );
    yield put(updateUserProfileSuccess({ data: profileResponse.data }));
    // update the auth user
    yield put(loginSuccess({ token: token, user: profileResponse.data }));
    yield put(successAlert("Profile update successfully!"));
  } catch (error) {
    yield put(
      errorAlert(
        typeof error === "string"
          ? error
          : typeof error?.error === "string"
          ? error?.error
          : "Error while updating profile!"
      )
    );
    yield put(updateUserProfileFailure({ error: error }));
  }
}
export function* changePassword({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const profileResponse = yield call(
      api(token).post,
      `api/users/change-password`,
      payload
    );
    yield put(chagePasswordSuccess({ data: profileResponse.data }));
    yield put(successAlert("Password updated successfully!"));
  } catch (error) {
    yield put(
      errorAlert(
        typeof error === "string"
          ? error
          : typeof error?.error === "string"
          ? error?.error
          : "Error while updating password!"
      )
    );
    yield put(chagePasswordFailure({ error: error }));
  }
}

// Action watchers

export function* watchLoadUsers() {
  yield takeEvery(LOAD_USERS, loadUsers);
}

export function* watchSaveUser() {
  yield takeEvery(USER_SAVE, saveUser);
}

export function* watchEditUser() {
  yield takeEvery(USER_EDIT, editUser);
}
export function* watchDeleteUser() {
  yield takeEvery(DELETE_USER, deleteUser);
}

export function* watchUpdateProfile() {
  yield takeEvery(UPDATE_USER_PROFILE, updateUserProfile);
}
export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePassword);
}

export default function* usersSaga() {
  yield all([
    watchChangePassword(),
    openUsersEditModalFlow(),
    openUsersViewModalFlow(),
    watchLoadUsers(),
    watchSaveUser(),
    watchDeleteUser(),
    watchEditUser(),
    watchUpdateProfile(),
  ]);
}
